import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/admin/arena-lessons', {
      params,
    })
    return response.data.data || null
  },
  async get(params) {
    let response = await api.get('/admin/arena-lessons/detail', {
      params,
    })
    return response.data.data || null
  },
  async update(payload) {
    let response = await api.put('/admin/arena-lessons', payload)
    return response
  },
  async updateBot(payload) {
    let response = await api.put('/admin/arena-lessons/sample-records', payload)
    return response
  },
  async create(payload) {
    const response = await api.post('/admin/arena-lessons', payload)
    return response.data.data.new_document || null
  },
  async delete(payload) {
    const response = await api.delete('/admin/arena-lessons', {
      data: payload,
    })
    return response
  },
  async updateOrder(payload) {
    const response = await api.post('/admin/arena-lessons/update-order', payload)
    return response
  },

}
